export default __webpack_public_path__ + "static/image041-2dc80c9d46f23b95dcc0017d07a44010.jpg";